import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BookingViewDtoServiceConfig = {
  name: "BookingViewDto",
  annotations: []
} as ServiceConfig;